import { useTrackUserProperty } from '../hooks/useTrackUserProperty';

/**
 * 인증된 사용자 식별 정보를 GTM dataLayer 에 동기화하는 mount-only 컴포넌트.
 * <ArtCloudAuthWrapper>(JWTAuthProvider) 자식 트리 안에 한 번만 마운트한다.
 * 렌더 결과는 없다.
 */
const UserPropertyTracker = (): null => {
  useTrackUserProperty();
  return null;
};

export default UserPropertyTracker;
